// ---------------------------------------------------------------------------
// DnD Email Editor – Column layout picker (shared)
//
// The visual "column types" picker: a row of thumbnails, each a miniature of a
// column layout preset sized to its real width ratios. Shared by the inspector
// (change an existing columns layer's layout) and the add-columns modal (choose
// the layout up-front when the block is first added) so the two never drift.
// ---------------------------------------------------------------------------

import type { ColumnsLayout } from './dnd-model';
import { COLUMN_WIDTH_RATIOS } from './dnd-columns';

export const LAYOUT_OPTIONS: { value: ColumnsLayout; label: string }[] = [
  { value: '1', label: '1 column' },
  { value: '2', label: '2 equal' },
  { value: '3', label: '3 equal' },
  { value: '4', label: '4 equal' },
  { value: '1:2', label: 'Narrow + wide' },
  { value: '2:1', label: 'Wide + narrow' },
  { value: '1:3', label: 'Sidebar left' },
  { value: '3:1', label: 'Sidebar right' },
];

// A miniature preview of a column layout, bars sized to the real ratios.
export function LayoutThumb({ layout }: { layout: ColumnsLayout }) {
  const ratios = COLUMN_WIDTH_RATIOS[layout] ?? [100];
  return (
    <span className="dnd-layout-thumb" aria-hidden="true">
      {ratios.map((r, i) => (
        <span key={i} className="dnd-layout-thumb-col" style={{ flexGrow: r }} />
      ))}
    </span>
  );
}

export function ColumnLayoutPicker({
  value,
  onSelect,
}: {
  value: ColumnsLayout;
  onSelect: (l: ColumnsLayout) => void;
}) {
  return (
    <div className="dnd-inspector-field">
      <label>Layout</label>
      <div className="dnd-layout-picker">
        {LAYOUT_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className={`dnd-layout-option${value === opt.value ? ' active' : ''}`}
            onClick={() => onSelect(opt.value)}
            title={opt.label}
            aria-pressed={value === opt.value}
          >
            <LayoutThumb layout={opt.value} />
          </button>
        ))}
      </div>
    </div>
  );
}
